import { Ng2StateDeclaration } from '@uirouter/angular';
import { FiAuthenticateHelpOtherComponent } from '@fi-app/authenticate/help-other/help-other.component';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiAuthStatesLoginHelpOtherState: Ng2StateDeclaration = {
    name: FiStateNames.Login.HelpOther,
    url: '/HelpOther',
    component: FiAuthenticateHelpOtherComponent,
    resolve: {
        pageTitle: [PageTitleService, FiAuthStatesLoginHelpOtherResolve_pageTitle_resolveFunc],
    },
};

export function FiAuthStatesLoginHelpOtherResolve_pageTitle_resolveFunc(pageTitleService: PageTitleService) {
    return pageTitleService.setTitle('Login Help Other');
}
